import React from 'react'

import Section from './../Section/index'
import CardBoxList from './../../organisms/CardBoxList'
import { SectionProps } from './../Section/types'
import { CardBoxListItemProps } from './../../organisms/CardBoxList/types'

export interface IProps extends SectionProps {
  data: CardBoxListItemProps[]
}

const YourFundsSection: React.FC<IProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,

  data
}) => (
  <Section
    {...{ id, inner, paddingTop, paddingBottom, headingPadding, bgColor, heading, isHeadingGreen, subheading, description }}
    body={<CardBoxList {...{ data }} />}
  />
)

export default YourFundsSection
